// extracted by mini-css-extract-plugin
export var container = "logo-module--container--1Aa9N";
export var active = "logo-module--active--1miHa";
export var expanded = "logo-module--expanded--kd-qc";
export var bounceLeft = "logo-module--bounce-left--2T-lU";